import React from "react";
import { motion } from "framer-motion";
export function About() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-17" data-mp="2prgtgp7izn5c">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="mx-auto max-w-2xl rounded-3xl bg-[var(--brand)] p-6 text-white sm:p-8" data-id="element-18" data-mp="2ps0eiesh2rnl">
        <h2 className="font-serif-display text-2xl font-extrabold sm:text-3xl" data-id="element-19" data-mp="2ypsnl17lp32j">
          🏥 Sobre la Dra. Karito
        </h2>
        <div className="mt-4 space-y-4 text-sm leading-relaxed text-white/85 sm:text-base" data-id="element-20" data-mp="38pt4kghzz73k">
          <p data-id="element-21" data-mp="3dgjca0dwbm1f">
            Durante años, la Dra. Karito atendió pacientes enfrentando el mismo desafío que viven
            miles de odontólogos: casos cada vez más complejos y demasiadas decisiones críticas que
            podían afectar el resultado final.
          </p>
          <p data-id="element-22" data-mp="3mfwoh0temopu">
            Con el tiempo comprendió que el verdadero problema no era la falta de conocimiento, sino
            la <strong className="text-white" data-id="element-23" data-mp="2lqz5mem010rr">ausencia de un método claro</strong> para tomar
            decisiones clínicas con confianza.
          </p>
          <p className="font-serif-display text-lg italic text-white" data-id="element-24" data-mp="2gqkw0s4r1irm">Así nació Protocolo Clínica Segura™.</p>
          <p data-id="element-25" data-mp="2cqstox5y88up">
            No como un curso más. No como un libro de teoría. Sino como un sistema práctico de
            protocolos, algoritmos y herramientas diseñado para ayudar a otros odontólogos a reducir
            la incertidumbre y trabajar con mayor previsibilidad en su día a día.
          </p>
        </div>
      </motion.div>
    </section>;
}